export default __webpack_public_path__ + "static/media/picDeleteMeeting.017bb898.svg";